var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-downloadable-item",class:{'bc-downloadable-item--disabled':_vm.disabled}},[_c('EditIcon',{attrs:{"icon":"download"},on:{"execute":_vm.download}}),_c('span',{on:{"click":_vm.download}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }